module.exports = __webpack_public_path__ + "img/repeat-04.58786636.svg";